const canvas = document.getElementById('clockCanvas');
const ctx = canvas.getContext('2d');

// Load all images
const baseBlack = new Image();
const baseWhite = new Image();
const insertMask = new Image();
const handsMask = new Image();
const marksMask = new Image();

baseBlack.src = 'https://cdn.shopify.com/s/files/1/0855/0152/files/base3_new.png?v=1761304331';
baseWhite.src = 'https://cdn.shopify.com/s/files/1/0855/0152/files/base3_inverse_ae2e661f-e8e8-49ac-bca7-cd12f06dbc10.png?v=1761304333';
insertMask.src = 'https://cdn.shopify.com/s/files/1/0855/0152/files/insertmask2.png?v=1761217530';
handsMask.src = 'https://cdn.shopify.com/s/files/1/0855/0152/files/handsmask.png?v=1761217532';
marksMask.src = 'https://cdn.shopify.com/s/files/1/0855/0152/files/12-marks.png?v=1761303674';

let base = baseBlack; // default black face
let insertColor = '#f4ee2a';
let handsColor = '#f4ee2a';
let marksColor = '#000000'; // only visible on white face

function draw() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(base, 0, 0, canvas.width, canvas.height);
  tint(insertMask, insertColor);
  tint(handsMask, handsColor);
  if (base === baseWhite) {
    tint(marksMask, marksColor);
  }
}

function tint(mask, color) {
  const t = document.createElement('canvas');
  t.width = canvas.width; t.height = canvas.height;
  const tc = t.getContext('2d');
  tc.drawImage(mask, 0, 0, t.width, t.height);
  tc.globalCompositeOperation = 'source-in';
  tc.fillStyle = color;
  tc.fillRect(0, 0, t.width, t.height);
  ctx.drawImage(t, 0, 0);
}

Promise.all([
  new Promise(r=>baseBlack.onload=r),
  new Promise(r=>baseWhite.onload=r),
  new Promise(r=>insertMask.onload=r),
  new Promise(r=>handsMask.onload=r),
  new Promise(r=>marksMask.onload=r)
]).then(draw);

// --- Swatch Handling ---
document.querySelectorAll('.swatch').forEach(swatch => {
  swatch.addEventListener('click', () => {
    const color =
      swatch.getAttribute('data-insert') ||
      swatch.getAttribute('data-hand') ||
      swatch.getAttribute('data-marks');

    if (swatch.hasAttribute('data-insert')) insertColor = color;
    if (swatch.hasAttribute('data-hand')) handsColor = color;
    if (swatch.hasAttribute('data-marks')) marksColor = color;
    draw();
  });
});

// --- Face Selector Handling ---
document.querySelectorAll('.face-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.face-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const face = btn.getAttribute('data-face');
    base = (face === 'white') ? baseWhite : baseBlack;

    const marksGroup = document.querySelector('.marks-group');
    if (face === 'white') {
      marksGroup.style.opacity = '1';
      marksGroup.style.pointerEvents = 'auto';
    } else {
      marksGroup.style.opacity = '0.4';
      marksGroup.style.pointerEvents = 'none';
    }

    draw();
  });
});
